import { useEffect, useState } from "react";
import { TechnologyData, getTechnology } from "../remote/scan_data"
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface TechnologyProps {
	id: string
	data?: TechnologyData | undefined
	hideChildren?: boolean
}

export const TechnologySimple = ({id, data=undefined}: TechnologyProps) => {
	const navigate = useNavigate()

	const [technologyData, setTechnologyData] = useState<TechnologyData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getTechnology(id, (data, resp) => {
				if (data) {
					setTechnologyData(data);
				} else {
					setTechnologyData(null);
				}
			});
		}
	}, [setTechnologyData]);

	return (technologyData
		? <Button onClick={() => navigate(`/tree/technology/${id}`)}>
			<Typography variant="body1" fontWeight={700} marginRight='1em'>Technology</Typography>{technologyData.technology} {technologyData.version}
		</Button>
		: <CircularProgress />
	)
}

export const Technology = ({id, data=undefined, hideChildren=false}: TechnologyProps) => {
	const navigate = useNavigate()

	const [technologyData, setTechnologyData] = useState<TechnologyData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getTechnology(id, (data, resp) => {
				if (data) {
					setTechnologyData(data);
				} else {
					setTechnologyData(null);
				}
			});
		}
	}, [setTechnologyData]);

	return (technologyData
		? <TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">Technology</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(technologyData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/technology/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
				<TableRow><TableCell align='left'>Technology</TableCell><TableCell align='right'>{technologyData.technology}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Version</TableCell><TableCell align='right'>{technologyData.version}</TableCell></TableRow>
				<TableRow><TableCell align='left'>CPE</TableCell><TableCell align='right'>{technologyData.cpe}</TableCell></TableRow>
				<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(technologyData.first_seen)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(technologyData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
